import { api } from './client'
import type { MappingDefinition, SavedMapping } from './types'

export const mappingsApi = {
  list(): Promise<SavedMapping[]> {
    return api.get<SavedMapping[]>('/mappings')
  },

  create(name: string, entityType: string, definition: MappingDefinition): Promise<SavedMapping> {
    return api.post<SavedMapping>('/mappings', { name, entityType, definition })
  },

  remove(id: string): Promise<void> {
    return api.delete<void>(`/mappings/${id}`)
  },
}
